import { Component } from '@angular/core';
import { DatePipe } from '@angular/common';
import { EnquiriesService } from './../services/enquiries.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ToastService } from './../services/toast.service';
import { MediaService } from './../services/media.service';
//import { AppConfig } from './../config/app-config';
import { SafeHtml, DomSanitizer, Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent {

  mediaReplacement$: string = "";
  EnquiryData$: FormGroup;

  Topics$: any[] = [
    { "id": 2, "title": "General Query" },
    { "id": 5, "title": "Automotive" },
    { "id": 6, "title": "Agro - processing" },
    { "id": 8, "title": "Chemical Manufacturing" },
    { "id": 9, "title": "Energy" },
    { "id": 10, "title": "Metals" },
    { "id": 11, "title": "Marketing and Communication" },
    { "id": 12, "title": "Logistics" },
    { "id": 13, "title": "Business Process outsourcing" },
    { "id": 14, "title": "Human Capital Solution" },
    { "id": 15, "title": "SMME Development Unit" }
  ];

  ResultMessage$: string = "";

  submitted: boolean = false;
  pageErrors: boolean = false;

  captchaInvalid: boolean = true;

  constructor(
    private datePipe: DatePipe,
    private enquiriesService: EnquiriesService,
    public toastService: ToastService,
    private mediaService: MediaService,
    protected sanitizer: DomSanitizer,
    private formBuilder: FormBuilder) {
    //console.clear();
    //console.log("constructed");
  }

  ngOnInit() {
    this.EnquiryData$ = this.formBuilder.group({
      id: [0, Validators.required],
      nameAndSurname: ['', Validators.required],
      emailAddress: ['', [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,9}$")]],
      topic: [2, Validators.required],
      message: ['', Validators.required],
      recaptchaReactive: null
    });
    //console.log("oninit");
    //this.loadMediaRelease();

  }

  resolved(captchaResponse: string) {

    if (captchaResponse == null) {
      this.captchaInvalid = true;
    }
    else {
      this.captchaInvalid = false;
    }
  }

  get f() { return this.EnquiryData$.controls; }

  sendEnquiry() {

    this.ResultMessage$ = "Submitting, please wait...";

    this.submitted = true;
    this.pageErrors = false;

    if (this.EnquiryData$.invalid) {
      this.pageErrors = true;
      this.ResultMessage$ = 'One or more fields are invalid.';
      return;
    }

    if (this.captchaInvalid == true) {
      this.pageErrors = true;
      this.ResultMessage$ = "Please complete the captcha";
      return;
    }

    var currentDate = new Date(this.datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm:ss.SSS'));

    let enquiry = {
      "id": 0,
      "SectionId": 0,
      "DateAdded": currentDate,
      "EnquiryProperties": []
    };

    enquiry.EnquiryProperties.push({ "key": "nameAndSurname", "value": this.EnquiryData$.controls.nameAndSurname.value });
    enquiry.EnquiryProperties.push({ "key": "emailAddress", "value": this.EnquiryData$.controls.emailAddress.value });
    enquiry.EnquiryProperties.push({ "key": "message", "value": this.EnquiryData$.controls.message.value });
    enquiry.EnquiryProperties.push({ "key": "topic", "value": this.Topics$.find(x => x.id == this.EnquiryData$.controls.topic.value).title });
    enquiry.EnquiryProperties.push({ "key": "topicId", "value": this.EnquiryData$.controls.topic.value.toString() });

    this.enquiriesService.saveEnquiry(enquiry).subscribe((response) => {
      this.ResultMessage$ = "Your message has been sent!";
      this.toastService.show('CONTACT US - Your message was successfully sent.', { classname: 'bg-success text-light', delay: 7500, autohide: true });
      this.EnquiryData$.reset();

      Object.keys(this.EnquiryData$.controls).forEach(key => {
        this.EnquiryData$.get(key).setErrors(null);
      });
      this.EnquiryData$.controls.recaptchaReactive = null;
    }, (error) => {
      this.ResultMessage$ = "An error occurred. Please try again later.";
      this.toastService.show('CONTACT US - An error occurred. Please try again later.', { classname: 'bg-danger text-light', delay: 7500, autohide: true });
      console.log(error);
    })
  }

  ngAfterContentInit() {
    //console.log("After Content Init");
    //loadMediaRelease();
    //this.loadMediaRelease();
    //setTimeout(() => {
    //  this.loadMediaRelease();
    //}, 2000);
    //setTimeout(function () {
    //  loadMediaRelease();
    //  console.log("Load called again...");
    //}, 2000);
  }

  ngAfterViewInit() {
    //console.log("After View Init");
    //this.loadMediaRelease();
  }

  loadMediaRelease() {
    //console.log("Loading media release...");
    try {
      this.mediaService.getFeaturedArticle().subscribe((response) => {
        //console.log("Got media article");
        const FeaturedArticle = response;//.find(x => x.featuredArticle === true);
        //console.log("Article Id: "+FeaturedArticle.id);
        if (FeaturedArticle.id > 0) {
          this.mediaReplacement$ = "<h3 class='title'>" + FeaturedArticle.title + "</h3>";
          this.mediaReplacement$ += "<p>" + FeaturedArticle.description + "</p>";
          this.mediaReplacement$ += '<a class="btn btn-default" href="./media/media-releases/media-article?mediaId=' + FeaturedArticle.id + '">Read <b>More </b><i class="fas fa-chevron-right"></i></a>';
          let content = $("#masterContentContainer").html();
          content = content.replace("<mediacontent></mediacontent>", this.mediaReplacement$);
          $("#masterContentContainer").html(content);
        }
      }, (error) => {
        console.error(error);
      });
    } catch (e) {
      console.error(e.message());
    }

  }

  contentLoaded(data) {
    //console.log("Content Loaded!!!");
    this.loadMediaRelease();
    //setTimeout(() => {
    //  this.loadMediaRelease();
    //}, 4000);
  }
}
